exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".size[data-v-5ad365a2]{margin:0 0 4mm}.printable-checkbox[data-v-5ad365a2]{display:inline-block;width:4.5mm;height:4.5mm;margin-right:2mm;border:1px solid #333;vertical-align:sub}.signature-line[data-v-5ad365a2]{border-top:1px solid #000;margin:30mm 0 0;width:80mm;font-size:.7rem;color:#888;padding:.2rem 0 0}.bigger[data-v-5ad365a2]{font-size:1.3rem}.indent[data-v-5ad365a2]{margin-top:3mm}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ad365a2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/OrderChecklistPDF.vue
// module id = 502
// module chunks = 0